import { trackingEvent } from '../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../analytics/utils';
import { store } from '../../../../redux/store';
import * as ganttActions from '../../../../redux/slices/ganttSlice';
import { getNextUID } from '../../../../views/ganttContainer/gantt/gantt.helper';

const DEFAULT_HOURS_PER_DAY = 8;

export const initializeNewTask = (item, ganttInstance, currentSector) => {
  if (!item.comesFromCopy && !item.comesFromUndo) {
    const numTasks = ganttInstance.getTaskByTime().length;
    item.text = numTasks === 1 ? 'New Master Plan' : 'New Activity';

    if (numTasks === 1) {
      const gridButtonColumn = ganttInstance.getGridColumn('buttons');
      if (gridButtonColumn) gridButtonColumn.label = 'Actions';
    }

    item.hhWorkTime = 0;
    item.cost = 0;
    item.used_cost = 0;

    item.should_be_showed = true;
    item.calendar_id = ganttInstance.defaultCalendar;
    item.activityModifications = [];
    item.pendingRequests = [];
    item.responsables = [];
    item.tags = [];
    item.subcontractId = null;
    item.real_constraint_type = item.constraint_type;

    if (!item.start_date) {
      item.start_date = new Date();
    }

    item.start_date.setHours(0);
    item.start_date.setMinutes(0);
    item.start_date_backup = item.start_date.toString();

    item.duration = currentSector?.hoursPerDay || DEFAULT_HOURS_PER_DAY;

    item.new_task = true;
    item.type = 'task';
    item.description = '';
  }
};

export const setTaskStartDate = (task, currentParent) => {
  if (currentParent) {
    task.start_date = currentParent.start_date;
  } else {
    task.start_date = new Date();
  }
};

export const configureTaskBeforeCreate = (config) => {
  const { task, currentParent, sector, gantt } = config;
  const { lastUniqueCorrelativeIds } = store.getState().ganttState;

  setTaskStartDate(task, currentParent);

  initializeNewTask(task, gantt, sector);

  const newUID = getNextUID(sector.id, lastUniqueCorrelativeIds, gantt);
  task.unique_correlative_id = newUID;
  task.isNewActivity = true;

  return newUID;
};

export const updateLastUniqueCorrelativeId = (config) => {
  const { sector, newUID } = config;
  const { lastUniqueCorrelativeIds } = store.getState().ganttState;
  const dispatch = store.dispatch;
  const oldObject = [...lastUniqueCorrelativeIds];
  const findObjectIndex = oldObject.findIndex(
    (el) => parseInt(el.sectorId) === parseInt(sector.id)
  );

  if (findObjectIndex !== -1) {
    oldObject[findObjectIndex] = {
      sectorId: sector.id.toString(),
      lastUniqueCorrelativeId: parseInt(newUID)
    };
    dispatch(ganttActions.setLastUniqueCorrelativeIds(oldObject));
    return oldObject;
  }

  return lastUniqueCorrelativeIds;
};

export const updateParentAfterTaskCreation = (
  parent,
  newTaskId,
  parentsToUpdate
) => {
  if (parent) {
    parent.is_lookahead = false;
    parent.hasNewActivities = true;

    if (!parent.newActivitiesArray) {
      parent.newActivitiesArray = [];
    }

    parent.newActivitiesArray.push(newTaskId);
    parentsToUpdate.add(parent);
  }
};

export const trackTaskCreation = (config) => {
  const { parent, newTaskId, task } = config;

  if (newTaskId) {
    trackingEvent(
      'schedule_activity_creation',
      {
        eventName: 'activity',
        ...getBasicAmplitudEventProperties(),
        parent_id: parent,
        activity_id: newTaskId,
        created_duration: task.duration
      },
      AMPLITUDE_SERVICE
    );
  }
};
